/**
 * Address utility functions
 */

export interface AddressData {
  DUNS?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

/**
 * Check if an address object has meaningful data
 * @param address - Address object to check
 * @returns true if at least one address field has a truthy value
 */
export function hasAddressData(address?: AddressData | null): boolean {
  if (!address) return false;
  // Check if at least one of the key address fields has data
  return Boolean(
    address.street ||
      address.city ||
      address.state ||
      address.zipCode ||
      address.DUNS,
  );
}
